
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops/[country]/[city]/[id]",
      function () {
        return require("private-next-pages/shops/[country]/[city]/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops/[country]/[city]/[id]"])
      });
    }
  